import styled, { css } from 'styled-components';
import FontSize from 'octa-front-sdk/dist/enums/FontSize';
import Color from 'octa-front-sdk/dist/enums/Color';
import { MediaQuery } from 'octa-front-sdk';

interface IPropsCard {
  unavailable?: boolean;
}

const Name = styled.h1`
  font-size: ${FontSize.Normal};
  color: #32264d;
  font-weight: bold;
  margin: 10px 10px 15px;
`;

const Description = styled.p`
  color: #6a6180;
  font-size: ${FontSize.SmallX};
  margin: 0 10px 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Price = styled.p`
  margin: auto 10px 10px;
  color: ${Color.Green500};
  font-weight: normal;
`;

const Ribbon = styled.div<IPropsCard>`
  width: 60%;
  padding: 5px 0;
  background-color: ${props =>
    props.unavailable ? Color.Grey500 : Color.MeuDeliveryCyan};
  color: ${Color.White};
  position: absolute;
  bottom: 25%;
  right: -15%;
  transform: rotate(-45deg);
  transform-origin: center;
  text-align: center;
  text-transform: uppercase;
`;

const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${MediaQuery.BiggerThanSmall} {
    max-width: 100%;
  }
`;

const Photo = styled.img`
  width: 100%;
  height: 100%;
`;

const PhotoContainer = styled.div`
  float: right;
  background-color: ${Color.Grey200};
  width: 90px;
  height: 90px;
  border-radius: 5px;
  margin: 10px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  ${MediaQuery.BiggerThanSmall} {
    width: 120px;
    height: 120px;
  }
`;

const Card = styled.div<IPropsCard>`
  width: 100%;
  min-height: 110px;
  background-color: ${Color.White};
  box-sizing: border-box;
  /* border: 1px solid ${Color.Grey300}; */
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 300ms ease;
  ${props =>
    props.unavailable &&
    css`
      opacity: 0.6;
      cursor: not-allowed;
    `}

  &:hover {
    ${props => props.unavailable && 'transform: scale(1.05);'}
  }

  > small {
    margin: 10px;
  }
`;

const DishCardStyles = {
  Name,
  Description,
  Price,
  Ribbon,
  InfoContainer,
  Photo,
  PhotoContainer,
  Card,
};

export default DishCardStyles;
